const CONFIRMATION_TYPE = {
    SAVE: 'save',
    APPOINTMENT: 'appointment',
    OFFICIAL_PARTIAL: 'official_partial',
    OFFICIAL_COMPLETED: 'official_completed',
};

export default CONFIRMATION_TYPE;
